import React, { useRef } from 'react';
import IdleTimer from 'react-idle-timer';

const IdleController = props => {
  const timeout = 1000 * 60 * 30; // 30 minutes
  const idleRef = useRef();

  const isIframeVisible = () => {
    const iframe = document.getElementById('noki-iframe');
    if (!iframe) return false;

    const rect = iframe.getBoundingClientRect();

    // Check if iframe is within viewport
    const isVisible =
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth);

    return isVisible;
  };

  const handleOnIdle = () => {
    debugger;
    if (!isIframeVisible()) {
      props.handleLogout();
    }
  };

  return (
    <IdleTimer
      ref={idleRef}
      timeout={timeout}
      onIdle={handleOnIdle}
      debounce={250}
    />
  );
};

export default IdleController;
